












































import ApplicationLayoutFluid from "@/layouts/ApplicationLayoutFluid.vue";
import RateQueueSearch from "@/views/rate-queue/partials/RateQueueSearch.vue";
import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { PriceOptimizerState, PriceOptimizerUnit } from "@/models";

const namespace = "priceOptimizer";

@Component({
  name: "RateQueue",
  components: {
    ApplicationLayoutFluid,
    RateQueueSearch
  }
})
export default class RateQueue extends Vue {
  // ===== Store ===== //
  @State("priceOptimizer") priceOptimizer!: PriceOptimizerState;
  @Action("publishRateChanges", { namespace })
  private publishRateChanges!: () => void;
  @Action("getPriceOptimizerUnits", { namespace })
  private getPriceOptimizerUnits!: () => void;
  @Getter("rateQueueSelectedRates", { namespace })
  rateQueueSelectedRates!: () => PriceOptimizerUnit[];
  @Mutation("setRateQueueSelectedRates", { namespace })
  private setRateQueueSelectedRates!: (selectedRates: PriceOptimizerUnit[]) => void;
  // ===== Data ===== //
  public confirmModal = false;
  // ===== Methods ===== //
  public clearSelectedFromRateQueue() {
    this.setRateQueueSelectedRates([]);
  }
  public async handleRateChanges(): Promise<void> {
    this.publishRateChanges();
    this.confirmModal = false;
  }
  public created() {
    this.getPriceOptimizerUnits();
  }
}
